import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const InfoBubbleFilledGlyph = /*#__PURE__*/createElement("g", {
  id: "info_1_"
}, /*#__PURE__*/createElement("path", {
  className: "st9",
  d: "M42,16c-14.5,0-26.3,11.8-26.3,26.3c0,12.5,8.7,22.9,20.3,25.6l2.6,2.9l3.5,5.2l5.3-7.8l0.1-0.2 c11.9-2.5,20.8-13.1,20.8-25.7C68.3,27.8,56.5,16,42,16z M39.8,27.4c0.6-0.6,1.3-0.8,2.1-0.8c0.8,0,1.5,0.2,2.1,0.8 s0.8,1.3,0.8,2.1c0,0.9-0.2,1.7-0.8,2.1s-1.2,0.8-2,0.8s-1.5-0.2-2.1-0.8c-0.6-0.5-0.9-1.3-0.9-2.1C38.9,28.7,39.2,28,39.8,27.4z M44.4,56.3h-4.7c-1.3,0-2.4-1.1-2.4-2.4s1.1-2.4,2.4-2.4V41c-1.3,0-2.4-1.1-2.4-2.4s1.1-2.4,2.4-2.4H42c1.3,0,2.4,1.1,2.4,2.4v13 c1.3,0,2.4,1.1,2.4,2.4S45.7,56.3,44.4,56.3z"
}));
const InfoBubbleFilled = createSvg({
  name: 'info_bubble_filled',
  path: InfoBubbleFilledGlyph
});

export default InfoBubbleFilled;
export { InfoBubbleFilledGlyph };
